const testimonios = [
  {
    name: "Carlos Andrés Mejía",
    role: "Propietario de Mitsubishi L200",
    city: "Medellín",
    text: "Llevaba semanas buscando una junta de culata para mi L200 y nadie la tenía. Octavio me la consiguió en 3 días. La asesoría fue increíble, me explicaron todo el proceso. 100% recomendados.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=Colombian%20man%2040%20years%20old%20professional%20portrait%20smiling%20confident%20natural%20lighting&width=80&height=80&seq=av001&orientation=squarish",
  },
  {
    name: "Sandra Milena Torres",
    role: "Propietaria de Montero Sport",
    city: "Bogotá",
    text: "Excelente servicio. Me atendieron por WhatsApp de forma muy rápida, me dieron el precio justo y el repuesto llegó a Bogotá en perfectas condiciones. Ya son mis proveedores de confianza.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=Colombian%20woman%2035%20years%20old%20professional%20portrait%20smiling%20confident%20natural%20lighting&width=80&height=80&seq=av002&orientation=squarish",
  },
  {
    name: "Jhon Fredy Ríos",
    role: "Mecánico especialista",
    city: "Cali",
    text: "Como mecánico, necesito proveedores confiables. Repuestos Octavio Ospina es mi primera opción para Mitsubishi. Conocen cada pieza, cada modelo. La calidad de los repuestos es impecable.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=Colombian%20mechanic%20man%2045%20years%20old%20professional%20portrait%20smiling%20confident%20natural%20lighting&width=80&height=80&seq=av003&orientation=squarish",
  },
];

export default function TestimoniosSection() {
  return (
    <section className="bg-[#F7F7F7] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
            Lo que dicen nuestros clientes
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black">
            Testimonios
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonios.map((t) => (
            <div key={t.name} className="bg-white rounded-xl p-8 flex flex-col">
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#E10600] text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <i className="ri-double-quotes-l text-[#E10600]/20 text-5xl leading-none mb-2"></i>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed italic flex-1 mb-6">
                {t.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="text-black font-black text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.role} &bull; {t.city}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
